/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Result_Group_Not_CompletedInputs */



/**
* | output |
* | --- |
* | "{count} actions did not complete" |
*
* @param {Chat_Tool_Result_Group_Not_CompletedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_group_not_completed = /** @type {((inputs: Chat_Tool_Result_Group_Not_CompletedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_Group_Not_CompletedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Aktionen wurden nicht abgeschlossen`)
	return /** @type {LocalizedString} */ (`${i?.count} actions did not complete`)
});